<template>
  <TableLayout :permissions="['business:labels:query']">
    <!-- 搜索表单 -->
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
      <el-form-item label="分类名称" prop="name">
        <el-input v-model="searchForm.name" placeholder="请输入名称" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <section>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </section>
    </el-form>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <ul class="toolbar" v-permissions="['business:labels:create', 'business:labels:delete']">
        <li><el-button type="primary" @click="$refs.operaLabelsWindow.open('新建标签信息表')" icon="el-icon-plus" v-permissions="['business:labels:create']">新建</el-button></li>
        <li><el-button @click="deleteByIdInBatch" icon="el-icon-delete" v-permissions="['business:labels:delete']">删除</el-button></li>
      </ul>
      <el-table
        v-loading="isWorking.search"
        :data="tableData.list"
        border
        stripe
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="name" label="分类名称" align="center" min-width="100px"></el-table-column>
        <el-table-column prop="imgurlfull" label="图标" align="center" min-width="100px">
          <template slot-scope="{row}">
            <!-- {{ row.imgFullurl }} -->
            <!-- <img src="@/assets/logo.png" alt=""> -->
            <el-image
              @error="showError"
              :lazy="true"
              style="with:50px;height:50px;"
              :scr="row.imgFullurl"
              :preview-src-list="[row.imgFullurl]"
              
            ></el-image>
            <!-- <el-image v-if="row.imgFullurl" :lazy="true" style="with:50px;height:50px;" scr="@/assets/logo.png" :preview-src-list="[row.imgurlfull]"></el-image> -->
          </template>
        </el-table-column>
        <el-table-column prop="sortnum" label="排序码(升序)" align="center" min-width="100px"></el-table-column>
        <el-table-column prop="createDate" label="创建时间" align="center" min-width="100px"></el-table-column>
        <el-table-column
          v-if="containPermissions(['business:labels:update', 'business:labels:delete'])"
          label="操作"
          min-width="120"
          fixed="right"
          align="center" 
        >
          <template slot-scope="{row}">
            <el-button type="text" @click="$refs.operaLabelsWindow.open('编辑标签信息表', row)" icon="el-icon-edit" v-permissions="['business:labels:update']">编辑</el-button>
            <el-button type="text" @click="deleteById(row)" icon="el-icon-delete" v-permissions="['business:labels:delete']">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
    </template>
    <!-- 新建/修改 -->
    <OperaLabelsWindow ref="operaLabelsWindow" @success="handlePageChange"/>
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import OperaLabelsWindow from '@/components/business/OperaArticleLabelsWindow'
export default {
  name: 'Labels',
  extends: BaseTable,
  components: { TableLayout, Pagination, OperaLabelsWindow },
  data () {
    return {
      // 搜索
      searchForm: {
        name: '',
        type: '8',
      },
      type: [
        // 0商品分类 1商品品牌 2商家标签 3快递 4退货选项 5换货选项 6退款选项 
        // 7取消订单选项 8咖啡百科分类 9咨询分类 10活动赛事分类 11达人探店分类
        { label: '商品分类', id: 0 },
        { label: '商品品牌', id: 1 },
        { label: '商家标签', id: 2 },
        { label: '快递', id: 3 },
        { label: '退货选项', id: 4 },
        { label: '换货选项', id: 5 },
        { label: '退款选项', id: 6 },
        { label: '取消订单选项', id: 7 },
        { label: '咖啡百科分类', id: 8 },
        { label: '咨询分类', id: 9 },
        { label: '活动赛事分类', id: 10 },
        { label: '达人探店分类', id: 11 }
      ]
    }
  },
  provide() {
    return {
      types: () => this.type
    }
  },
  created () {
    this.config({
      module: '标签信息表',
      api: '/business/labels',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
  },
  methods: {
    showError(e) {
      console.log(e);
    }
  },
}
</script>
